import { setItem } from 'owa-local-storage';
import { ocpsLocalStorageUpdated, type OcpsStoreUpdateType } from '../actions/actions';
import type { OcpsPolicyStore } from '../store/schema/OcpsPolicyStore';
import { USER_OCPS_POLICY_STORE } from './constants';

export function updateOcpsLocalStorage(
    newOcpsPolicyStore: OcpsPolicyStore,
    updateType?: OcpsStoreUpdateType
): void {
    setItem(window, USER_OCPS_POLICY_STORE, JSON.stringify(newOcpsPolicyStore));

    // If not update type specified, it defaults to POLICY_VALUES
    ocpsLocalStorageUpdated(updateType ?? 'POLICY');
}
